<app-image-picker
  *ngIf="!readOnly"
  [imageParentType]="type"
  [parentId]="parentId"
  [disabled]="(images$ | async)?.length === maxImagesCount"
  class="flex row w-100"
></app-image-picker>
<form [formGroup]="form" class="images-container easy-form">
  <ng-container formArrayName="imageNames">
    <ng-container *ngIf="images$ | async as images">
      <div
        *ngFor="
          let imageNameControl of imageNameFormArray.controls;
          let i = index
        "
        class="image-card"
        [class.image-card--default]="images[i].isDefault"
      >
        <div>
          <mat-card class="mat-card">
            <div
              class="image-card__image"
              [style.background-image]="
                'url(' + imageBaseUrl + images[i].smallUrl + ')'
              "
            ></div>
            <div
              *ngIf="images[i].isDefault"
              class="mat-raised-button mat-primary image-card__default-label"
            >
              {{ "SHARED.IMAGE_PICKER.DEFAULT_IMAGE" | translate }}
            </div>
          </mat-card>

          <div class="d-flex gap-3 image-card-btn-container">
            <mat-form-field
              class="image-card__text"
              [formGroup]="getImageNameForm(i)"
            >
              <app-easy-input
                formControlName="name"
                [label]="'SHARED.IMAGE_PICKER.IMAGE_TITLE' | translate"
                (keyup)="onNameInput($event, i, images[i])"
              >
              </app-easy-input>
              <!--

                                  <mat-label>{{
                  "SHARED.IMAGE_PICKER.IMAGE_TITLE" | translate
                }}</mat-label>
                <input
                  matInput
                  formControlName="name"
                  (keyup)="onNameInput($event, i, images[i])"
                />

                -->
            </mat-form-field>
            <button
              *ngIf="!readOnly"
              [disabled]="nameChanged(i) ? null : true"
              type="button"
              mat-icon-button
              color="primary"
              class="image-card__text-button filled"
              (click)="saveNameInput(i, images[i])"
              [attr.aria-label]="
                'SHARED.IMAGE_PICKER.SAVE_IMAGE_TITLE' | translate
              "
            >
              <mat-icon>save</mat-icon>
            </button>
          </div>

          <div class="image-card__buttons" *ngIf="!readOnly">
            <button
              type="button"
              mat-raised-button
              color="primary"
              (click)="setDefault(images[i])"
              [disabled]="images[i].isDefault ? true : null"
            >
              {{ "SHARED.IMAGE_PICKER.SET_DEFAULT_IMAGE" | translate }}
            </button>
            <button
              type="button"
              mat-stroked-button
              color="primary"
              (click)="deleteImage(images[i].id)"
              [disabled]="
                !images[i].isDefault || images.length === 1 ? null : true
              "
            >
              {{ "SHARED.IMAGE_PICKER.DELETE_IMAGE" | translate }}
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
</form>
